const loader = (state = { isLoading: false }, action) => {
  const isLoading = action.isLoading;
  if (action.isLoading !== undefined) return { ...state, isLoading: isLoading };

  return { ...state };
};

export default loader;
